import apollo from 'graphql/apollo';
import { moveInputFieldMutation } from 'graphql/mutations';

const moveCategoryInputField = (categoryListQuery) => async ({ _id, offset, order }) =>
  apollo.mutate({
    mutation: moveInputFieldMutation,
    variables: { _id, offset, order },
    refetchQueries: [{ query: categoryListQuery }],
  });
export default moveCategoryInputField;
